import React, { useEffect, useState } from "react";

import { Nav, NavItem, Badge, ToggleOption, Modal, Checkbox, Button } from "bootstrap-micro";
import { Route, Switch } from "react-router";

import { usePanels } from "../store/panelsSlice.js";
import { siteEmailEvents, siteRemove, siteUpdateName, usePanelEventCount, useSite, useUnreadCount } from "../store/sitesSlice.js";

import IMG_PANEL from "img/panels/smartloop_mk2.png";
import IMG_PANEL_MMP from "img/panels/multiloop.png";
import IMG_UNKNOWN from "img/panels/unknown.png";
import DataTable, { Row } from "../DataTable.jsx";
import { useParams } from "react-router-dom";
import EventsTab from "../panel/tabs/EventsTab.jsx";
import { useDispatch, useSelector } from "react-redux";
import { NotificationsTab } from "../panel/tabs/NotificationsTab.jsx";
import { getNotificationCount } from "../store/notificationsSlice.js";

const IMG_PANEL_MAP = {
    SMARTLOOP_MK2: IMG_PANEL,
    MULTILOOP: IMG_PANEL_MMP,
    UNKNOWN: IMG_UNKNOWN,
};

const PanelWidget = ({ site, networkId, name }) => {
    const eventCount = usePanelEventCount(site.hwaddr, networkId);
    return (
        <div
            className="panel-widget"
            onClick={() => {
                location.hash = `/site/${site.hwaddr}/panel/${networkId}`;
            }}
        >
            <img src={IMG_PANEL_MAP[site.panelType]} className="panel-widget__icon" />
            <h4>{name} {(eventCount > 0 ? <Badge>{eventCount}</Badge>:null)}</h4>
        </div>
    )
}

const SiteConfig = () => {
    const { hwaddr } = useParams();
    const site = useSite(hwaddr);

    const [name, setName] = useState("");

    const dispatch = useDispatch();

    useEffect(() =>{
        if(site && name == "")
        {
            setName(site.name);
        }
    }, [ site ])

    const [showRemoveModal, setShowRemoveModal] = useState(false);
    const [removeConfirmed, setShowRemoveConfirmed] = useState(false);

    return (
        <React.Fragment>
            <DataTable>
                <Row label="MAC Address">
                    {site ? site.hwaddr.match(/[0-9a-f]{2}/g).join(":") : "..."}
                </Row>
                <Row label="Nickname">
                    {" "}
                    <input
                        className="form-control"
                        type="text"
                        value={name}
                        onChange={ev => setName(ev.target.value)}
                    />
                    <Button type="button" disabled={ (name == "" || (site ? name == site.name : true )) } onClick={ () => dispatch(siteUpdateName(site.hwaddr, name)) }>Update</Button>
                </Row>

                <Row label="Email Fire/Fault events to me" noParagraph={true}>
                    <ToggleOption
                        disabled={site == null}
                        value={site != null ? site.emailEvents : false}
                        onClick={() => {
                            dispatch(siteEmailEvents(site.hwaddr, !site.emailEvents));
                            //setEmailEvents(!emailEvents)
                        }}
                    />
                </Row>
                <Row label="Remove site">
                    <button
                        className="btn btn-danger btn-block"
                        type="button"
                        onClick={() => setShowRemoveModal(true)}
                    >
            Remove Myself From This Panel
                    </button>
                </Row>
                {/* <Row label="debug">
                    <pre>{JSON.stringify(site, null, 2)}</pre>
                </Row> */}
            </DataTable>
            <Modal show={showRemoveModal} onHide={() => setShowRemoveModal(false)} >
                <Modal.Header closeButton>
                    <Modal.Title>Remove access to this panel.</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Continuing will remove your ability to access this panel, are you sure you wish to proceed?</p>
                    <Checkbox checked={removeConfirmed} onChange={() => setShowRemoveConfirmed(!removeConfirmed)} >
                        <strong>I confirm I wish to remove my access to this panel.</strong>
                    </Checkbox>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        bsStyle="danger"
                        disabled={!removeConfirmed}
                        onClick={() => dispatch(siteRemove(hwaddr)).then(() => { location.href="/#/"; })}
                    >Remove Access</Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
};

const SiteEvents = () => <EventsTab />;

const SitePanels = () => {
    const { hwaddr } = useParams();
    const site = useSite(hwaddr);
    const panels = usePanels(hwaddr);
    
    return (
        <div id="devices">
            {panels.map((p) => (
                <PanelWidget
                    key={p.networkId}
                    site={site}
                    networkId={p.networkId}
                    name={p.strName}
                />
            ))}
        </div>
    );
};

export const SiteManager = (props) => {

    // Force loading of data
    useSite(props.match.params.hwaddr);
    usePanels(props.match.params.hwaddr);

    
    const unresolvedNotifications = useSelector(getNotificationCount(props.match.params.hwaddr));
    const unreadEvents = useUnreadCount(props.match.params.hwaddr);


    return (
        <div>
            <div className="fluid-container">
                <div role="tabpanel" className="nav-center">
                    <Nav bsStyle="tabs" activeHref={window.location.hash}>
                        <NavItem
                            className="nav-tabs__tab"
                            href={`#${props.match.url}/events`}
                            // onClick={() => props.resetEventCount(props.match.params.hwaddr) }
                        >
              Events&nbsp;
                            {unreadEvents > 0 ? <Badge>{unreadEvents}</Badge> : null}
                        </NavItem>
                        <NavItem className="nav-tabs__tab" href={`#${props.match.url}`}>
              Panels
                        </NavItem>
                        
                        <NavItem className="nav-tabs__tab" href={`#${props.match.url}/notifications`}>Notifications&nbsp;{unresolvedNotifications > 0 ? <Badge>{unresolvedNotifications}</Badge> : null}</NavItem>
                        <NavItem
                            className="nav-tabs__tab"
                            href={`#${props.match.url}/about`}
                        >
              Site Configuration
                        </NavItem>
                    </Nav>
                </div>
            </div>
            <div className="container" style={{ paddingTop: "20px" }}>
                <Switch>
                    <Route path={`${props.match.path}/about`} component={SiteConfig} />
                    <Route path={`${props.match.path}/events`} component={SiteEvents} />
                    <Route exact path={`${props.match.path}/notifications`} component={NotificationsTab} />
                    <Route component={SitePanels} />
                </Switch>

                <hr />
            </div>
        </div>
    );
};

export default SiteManager;
